import { saveUser } from 'communicator/store';
import { getAccessToken, getSessionId } from 'communicator/store/selectors';
import fetchRenewal from 'communicator/utils/api/renewal';

export default async function sessionRenewal() {
  try {
    const renewalResponse = await fetchRenewal({
      accessToken: getAccessToken()?.token ?? '',
      sessionId: getSessionId()
    });

    if (!renewalResponse.ok) {
      return { error: renewalResponse };
    }

    saveUser({
      accessToken: {
        expiresIn: renewalResponse.data.expires_in,
        isPartial: false,
        token: renewalResponse.data.access_token
      }
    });

    return renewalResponse.data;
  } catch (e) {
    /* istanbul ignore next */
    return { error: e };
  }
}
